import React, { Component } from "react";
import { ajaxManage, unparam } from "utils/common";
//css
import "./index.less";
//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd0c4bfd889805b2d&redirect_uri=http%3A%2F%2F192.168.0.211%2Fbind&response_type=code&scope=snsapi_base&state=123#wechat_redirect

class App extends Component {
	state = {
		openId: ""
	}

	componentDidMount(){
        document.title = "绑定微信"
        //获取页面参数
        const queryString = unparam(window.location.search);

		ajaxManage({
			url: "/wechat/getOpenid",
			data: {
				code: queryString.code
			}
		}).then(res => {
			this.setState({
				openId: res.data
			})
		}).catch(err => {
			this.setState({
				openId: "获取openId失败！"
			})
		})
	}

  	render() {
  		const { openId } = this.state;
    	return (
    		<div className="bind-wrap">
    			<h1 className="bind-title-small">openId: { openId }</h1>
    			<p>请把上面的openId发给视频面试系统管理员进行绑定</p>
    		</div>
		);
	}
}

export default App;